export class Entitlements {
    cnfmEntitlement: boolean;
    taxEntitlement: boolean;
    notfEntitlement: boolean;
    stmtEntitlement: boolean;
    qprEntitlement: boolean;
    // pendingEnrollEntitlement: boolean;
    fullEnrollEntitlement: boolean;
}
